export const MS_INTERNAL_ERROR = "Error al realizar la accion";
export const MS_NOT_FOUND_ERROR = "No se ha encontrado respuesta a la solicitud";
export const MS_SESSION_EXPIRED = "Su sesion ha expirado";
export const MS_UNAUTHORIZED_ERROR = "No esta autorizado para realizar esta accion";
export const MS_UNKNOWN_ERROR = "Error al realizar la accion";
export const TOKEN_EXPIRED = "Token expired";
export const MS_FORBIDDEN_ERROR = "Peticion prohibida";
export const PATHS = {
    REPORTES: {
        CONSOLIDADO_PROVEEDOR: 'consolidado-proveedor',
        ESTRACTO_D_PROVEEDOR: 'estracto-d-proveedor',
        ESTRACTO_M_PROVEEDOR: 'estracto-m-proveedor',
        CONSOLIDADO_CONDUCTOR: 'consolidado-conductor',
        ESTRACTO_D_CONDUCTOR: 'estracto-d-conductor'
    }
}
export const TABLES_TITLES = Object.freeze({
    [PATHS.REPORTES.CONSOLIDADO_PROVEEDOR]: [
        { title: "Ruta", sort: "Cupo.Rutum.nombre" },
        { title: "Nombre", sort: "Proveedor.nombre" },
        { title: "Cédula", sort: "Proveedor.cedula" },
        { title: "D.V.", sort: "Proveedor.dv" },
        { title: "Cupo", sort: "Cupo.codigo", name: "Cupo.codigo" },
        { title: "Litros", sort: "cantidad", name: "cantidad_total" },
        { title: "Precio unitario", sort: "Proveedor.precio_litro" },
        { title: "Pago", sort: "pago_planta" },
        { title: "Precio subsidio", sort: "precio_subsidio" },
        { title: "Pago subsidio", sort: "pago_subsidio" },
        { title: "Pago total", sort: "pago_total" }
    ],
    [PATHS.REPORTES.ESTRACTO_D_PROVEEDOR]: [
        { sort: "cedula", title: "Cédula" },
        { sort: "nombre", title: "Nombre" },
        { sort: "codigo", title: "Código" },
        { sort: "total", title: "Total" },
        { sort: "precio", title: "Precio" },
        { sort: "precio_subsidio", title: "Precio Subsidio" },
        { sort: "preciofinal", title: "Pago" },
    ],
    [PATHS.REPORTES.CONSOLIDADO_CONDUCTOR]: [
        { title: "Cédula", sort: "cedula" },
        { title: "Nombre", sort: "nombre" },
        { title: "Litros Total", sort: "totalLitros" },
        { title: "Tipo de Pago", sort: "tipoPago" },
        { title: "Precio", sort: "pago" },
        { title: "Total del Pago", sort: "totalPago" },
    ],
    [PATHS.REPORTES.ESTRACTO_D_CONDUCTOR]: [
        { title: "Cédula", sort: "cedula" },
        { title: "Nombre", sort: "nombre" },
        { title: "Tipo de Pago", sort: "tipoPago" },
        { title: "Precio", sort: "pago" },
        { title: "Total del Pago", sort: "totalPago" },
    ]
})
